export const dispatchUpdateOwners = () => {
  document.dispatchEvent(new CustomEvent('application-owners: update'));
};
